import $ from 'jquery';

// Modaal is not a spelling error!
// It is the name of the 3rd party modal component we are using
export const ELEMENT_SELECTOR = '[data-modal]';
export const PLUGIN_NAME = 'modal';

$(document).ready(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "component--modal" */ './modal'
		).then(() => {
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/modal/index.js